import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { watchlistsAddAsset } from '../../../lib/aws_api';

import { setWatchlistData } from '../../../redux/slices/watchlistDataSlice'

import '../../../css/components/pages/Watchlist/AddAssetModal.css'
import TagInput from '../../common/tags/TagInput';

export default function AddAssetModal(props) {
    const dispatch = useDispatch()
    let accessToken = useSelector(state => state.accessToken.value)
    let user = useSelector(state => state.user.value)

    const [tags, setTags] = useState([]);

    async function handleSubmit(e){
        e.preventDefault()
        props.loadingFunc(true)

        //parse form data from event
        let ticker = e.target.elements.ticker.value
        let asset_type = e.target.elements.asset_type.value

        let asset = {
            ticker,
            asset_type,
            tags
        }

        let watchlist_data = await watchlistsAddAsset(user,accessToken,asset,props.selectedWatchlist)

        // let watchlist_data = result.data.watchlist_data
        dispatch(setWatchlistData(watchlist_data))

        props.setOpenAddAssetModal(false)
        props.loadingFunc(false)
    }

    if(!props.open){
        return null
    }

    return (
        <div className='add-watchlist-modal'>
            <h2>Add Asset to "{props.selectedWatchlist}" Watchlist</h2>
            <form className='add-watchlist-form' onSubmit={handleSubmit}>
                <div><label>Ticker: </label><input type='text' name='ticker' placeholder='ticker'/></div>
                <div><label>Asset Type: </label><input type='text' name='asset_type' placeholder='asset_type'/></div>

                <TagInput onTagsChange={(newTags) => setTags(newTags)} />

                <button type='submit'>Submit</button>
            </form>
        </div>
    )
}
